import React, { FC } from 'react'
import { IllustrationName } from '@pandiafi/design-system'

import { Error, View } from 'components'

type Props = {
  title?: string
  message?: string
  illustration?: IllustrationName
  eventId?: string
  action?: React.ReactNode
}

export const ErrorPage: FC<Props> = (props) => {
  return (
    <View>
      <View.Header>
        <div className="h-10" />
      </View.Header>

      <View.Sidebar />

      <View.Content>
        <Error {...props} className="desktop:pb-0" />
      </View.Content>
    </View>
  )
}
